<div appDragScroll
     class="pill-container">
  <app-pill *ngFor="let p of pillsIn"
            [pillItem]="p"
            (changed)="changed()">
  </app-pill>
</div>
